import { defineComponent, reactive, toRefs, onMounted, onBeforeUnmount, 
// nextTick,
computed, ref, watch, } from 'vue';
// import { withInstall } from '../_util/type';
import useConfigInject from '../_util/hooks/useConfigInject';
import Dropdown from '../dropdown';
import Menu, { MenuItem } from '../menu';
import { OperationType } from './utils/types';
import Icon from '../icon';
import classNames from '../_util/classNames';
export const linkProps = () => ({
    padding: {
        type: Number,
        default: 50, // 画布内的x起点
    },
    linkDesc: {
        type: Object,
        default: () => { },
    },
    linkStyle: {
        type: Object,
        default: () => { },
    },
    nodeList: {
        type: Array,
        default: () => [],
    },
    modelPathList: {
        type: Array,
        default: () => [],
    },
    linkBaseStyle: Object,
    index: Number,
    graph: Object,
    link: Object,
    merge: Boolean,
    selectedActiveId: Number,
    linkSelect: Function,
    // handleLabelClick: Function as PropType<(payload: MouseEvent) => void>,
    menus: Array,
    menuClick: Function,
    readonly: Boolean,
    lightenLinkIds: Array,
    getMenuPopupContainer: { type: Function },
});
const StgyFlowLink = defineComponent({
    compatConfig: { MODE: 3 },
    name: 'WdStgyFlowLink',
    props: linkProps(),
    // emits: ['handle-link-label'],
    setup(props) {
        const { prefixCls, configProvider } = useConfigInject('stgy-flow-line', props);
        const state = reactive({
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            currentPointList: [],
            currentPathPointList: null,
            label: {
                text: '添',
                top: null,
                left: null,
                // right: null,
            },
            canvasCtx: null, // 画布上下文
        });
        const { top, right, bottom, left, currentPointList, currentPathPointList, label, canvasCtx } = toRefs(state);
        const { padding, linkBaseStyle, graph, link, selectedActiveId, menus, readonly, getMenuPopupContainer, merge, nodeList,
        // modelPathList,
         } = toRefs(props);
        const canvasRef = ref();
        onMounted(() => {
            canvasCtx.value = canvasRef.value.getContext('2d');
            draw();
            // nextTick(() => {
            //   initDesc();
            // });
            graph.value.add('mousemove', rootMousemove);
            graph.value.add('mousedown', rootMousedown);
        });
        onBeforeUnmount(() => {
            graph.value.remove('mousemove', rootMousemove);
            graph.value.remove('mousedown', rootMousedown);
        });
        // 开始节点是否为合并节点
        const isMergeNodeStart = computed(() => {
            const startId = link.value.start.id;
            const node = nodeList.value.find(node => node.id === startId);
            return node?.meta?.extParam?.isMergeNode;
        });
        const isActive = computed(() => {
            return ((selectedActiveId.value !== -1 && selectedActiveId.value === link.value.meta?.activeId) ||
                link.value.meta?.isHighLight);
        });
        const activeColor = computed(() => {
            return configProvider?.mode === 'light' ? '#FF9917' : '#e8a33c';
        });
        const defaultColor = computed(() => (configProvider?.mode === 'light' ? '#C7CBD6' : '#9094a9'));
        const dragColor = computed(() => (configProvider?.mode === 'light' ? '#2469F2' : '#3578fd'));
        const lineColor = computed(() => {
            if (link.value?.meta?.isDragElement) {
                return dragColor.value;
            }
            else {
                return isActive.value ? activeColor.value : defaultColor.value;
            }
        });
        const styles = computed(() => {
            return Object.assign({
                hover: '#FF0000',
                color: lineColor.value,
                textColor: '#666666',
                textHover: '#FF0000',
                font: '14px Arial',
                dotted: false,
                lineDash: [4, 4],
                background: 'rgba(255,255,255)',
            }, linkBaseStyle.value);
        });
        const inPath = computed({
            get() {
                return graph.value.mouseOnLink === link.value?.id;
            },
            set(bol) {
                // 鼠标移入线段
                if (bol && !graph.value.mouseonNode) {
                    // 鼠标移入线段 && 鼠标未移入节点
                    // 标记
                    graph.value.mouseOnLink = link.value?.id;
                    // canvasRef.value.style.zIndex = '1';
                }
                else if (inPath.value) {
                    graph.value.mouseOnLink = null;
                    // canvasRef.value.style.zIndex = '0';
                }
            },
        });
        const appendDisabled = computed(() => {
            // 取消合并后重置【添】状态
            return (
            // (!link.value.meta?.canAdd &&
            //   isNodeInMerge({
            //     nodeId: link.value.end.id,
            //     modelPathList: modelPathList.value,
            //     nodeList: nodeList.value,
            //   })) ||
            merge.value);
        });
        watch(() => [isActive.value, configProvider?.mode], () => {
            initLine();
        });
        // 获取设备像素比
        const devicePixelRatio = () => {
            if (typeof window == 'undefined')
                return 1;
            return window.devicePixelRatio || 1;
        };
        const draw = () => {
            const { pointList, minX, minY, maxX, maxY } = link.value.pathPointList;
            currentPathPointList.value = link.value.pathPointList;
            top.value = minY - padding.value;
            right.value = maxX + padding.value;
            bottom.value = maxY + padding.value;
            left.value = minX - padding.value;
            const offset = 0.5;
            currentPointList.value = pointList.map(point => {
                return [
                    Math.floor(point[0] - left.value) + offset,
                    Math.floor(point[1] - top.value) + offset,
                ];
            });
            changeStyle();
            initLine();
            changeCanvaszIndex();
        };
        // 修改画布层级
        const changeCanvaszIndex = () => {
            if (link.value?.meta?.isHighLight) {
                canvasRef.value.style.zIndex = '1';
            }
            else {
                canvasRef.value.style.zIndex = '0';
            }
        };
        const changeStyle = () => {
            const dpr = devicePixelRatio();
            canvasRef.value.width = (right.value - left.value) * dpr;
            canvasRef.value.height = (bottom.value - top.value) * dpr;
            canvasRef.value.style.width = right.value - left.value + 'px';
            canvasRef.value.style.height = bottom.value - top.value + 'px';
            canvasRef.value.style.top = top.value + 'px';
            canvasRef.value.style.left = left.value + 'px';
            canvasCtx.value.scale(dpr, dpr);
        };
        const initLine = () => {
            const ctx = canvasCtx.value;
            ctx.clearRect(0, 0, canvasRef.value.width, canvasRef.value.height);
            const color = styles.value.color;
            drawLine(color);
            drawArrow(color);
            initDesc();
        };
        const drawLine = strokeStyle => {
            const lineWidth = 1;
            const ctx = canvasCtx.value;
            ctx.beginPath();
            if (styles.value.dotted) {
                ctx.setLineDash(styles.value.lineDash);
            }
            ctx.lineWidth = lineWidth;
            ctx.strokeStyle = strokeStyle;
            currentPointList.value.forEach((point, idx) => {
                if (idx === 0) {
                    ctx.moveTo(...point);
                }
                else {
                    ctx.lineTo(...point);
                    ctx.stroke();
                }
            });
            ctx.save();
        };
        const initDesc = () => {
            // 开始点的位置
            const [startX] = currentPointList.value[currentPointList.value.length - 2];
            // 结束点的位置
            const y = currentPointList.value[currentPointList.value.length - 1]?.[1];
            const distance = 8;
            label.value.top = top.value + y + 'px';
            label.value.left = left.value + startX + distance + 'px';
        };
        const drawArrow = fillStyle => {
            const size = 4;
            const len = currentPointList.value.length;
            if (len < 2)
                return;
            const start = currentPointList.value[0];
            const end = currentPointList.value[len - 1];
            const ctx = canvasCtx.value;
            if (link.value?.meta?.activeId === -1) {
                // 移动中心点
                ctx.translate(...end);
                ctx.beginPath();
                ctx.arc(-size + 0.5, 0, 3, 0, Math.PI * 2, true);
                ctx.fillStyle = fillStyle;
                ctx.fill();
                ctx.restore();
                ctx.save();
            }
            if (isMergeNodeStart.value)
                return;
            ctx.translate(...start);
            ctx.beginPath();
            ctx.arc(size / 2 + 0.5, 0, 3, 0, Math.PI * 2, true);
            ctx.fillStyle = fillStyle;
            ctx.fill();
            ctx.restore();
        };
        const getCoordinates = evt => {
            // 鼠标的 x轴 y轴 坐标
            const { clientX, clientY } = evt;
            // link 所在的top left
            const { top, left } = canvasRef.value.getBoundingClientRect();
            // 鼠标x - left值；鼠标y - top值
            return [clientX - left, clientY - top];
        };
        const isPointInStroke = evt => {
            if (evt.target !== canvasRef.value)
                return false;
            const [x, y] = getCoordinates(evt);
            return link.value.isPointInLink([left.value + x, top.value + y], currentPathPointList.value);
        };
        const rootMousemove = ({ evt }) => {
            inPath.value = isPointInStroke(evt);
            // return inPath.value;
        };
        const rootMousedown = () => {
            // inPath.value = isPointInStroke(evt);
            // return inPath.value;
            const activeId = link.value?.meta?.activeId;
            if (inPath.value && link.value?.meta?.activeId !== -1 && !merge.value) {
                props.linkSelect(activeId);
            }
        };
        const handleMenuClick = (key) => {
            props.menuClick({ type: OperationType.APPEND, key, link: link.value });
        };
        return () => {
            // 添加节点
            let addNode = null;
            if (link.value.meta?.activeId === -1 && !readonly.value && !link.value.meta?.isDragElement) {
                const style = {
                    top: label.value.top,
                    // right: label.value.right,
                    left: label.value.left,
                };
                addNode = (<>
            <Dropdown trigger={'click'} getPopupContainer={getMenuPopupContainer.value} disabled={appendDisabled.value} destroyPopupOnHide v-slots={{
                        overlay: () => (<Menu onClick={({ key }) => {
                                handleMenuClick(key);
                            }}>
                    {menus.value.map(menu => {
                                return <MenuItem key={menu.value}>{menu.name}</MenuItem>;
                            })}
                  </Menu>),
                        default: () => (<div style={style} class={classNames({
                                [`${prefixCls.value}__label-box`]: true,
                                [`${prefixCls.value}__label-disabled`]: appendDisabled.value,
                            })}>
                    <div class={`${prefixCls.value}__label`}>
                      {/* {label.value.text} */}
                      <Icon icon-class="wd-icon-special_append"></Icon>
                    </div>
                  </div>),
                    }}></Dropdown>
          </>);
            }
            return (<>
          <canvas ref={canvasRef} class={`${prefixCls.value}`}></canvas>
          {addNode}
        </>);
        };
    },
});
export default StgyFlowLink;
